module.exports = __webpack_public_path__ + "img/PM_A02_back_en.7fa679fc.png";